<template>
  <div class="pageBox">
    <el-row>
      <el-col :span="8">
        <el-col>
          <el-card class="box-card" style="margin-top: 2px;">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_heart.png"/>
              <span>心率/每分钟</span>
            </div>
            <p class="box_txt">{{heart}}</p>
          </el-card>
        </el-col>
        
        <el-col>
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <img src="@/assets/device/radar/icon_rr.png"/>
                <span>离床持续时间</span>
              </div>
              <p class="box_txt">{{outduration}}</p>
            </el-card>
        </el-col>
      </el-col>  
      <el-col :span="8">
        <el-col>
          <el-card class="box-card" style="margin-top: 2px;">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_breath.png"/>
              <span>呼吸/每分钟</span>
            </div>
            <p class="box_txt">{{breathe}}</p>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_rr.png"/>
              <span>RR间隔</span>
            </div>
            <p class="box_txt">{{rr}}</p>
          </el-card>
        </el-col>
      </el-col>  
      <el-col :span="8">
        <el-card class="box-card" style="margin-top: 2px;">
          <div slot="header" class="clearfix">
            <img src="@/assets/device/radar/icon_data.png"/>
            <span>实时数据</span>
          </div>
          <div style="background-color: #CCDCEB;">
            <ul class="infinite-list" style="overflow:auto">
              <li v-for="i in data2List" :key="i" class="infinite-list-item">
                <el-card class="card2">
                  {{ i }}
                </el-card>
              </li>
            </ul>
            <div class="echartsBox">
              <div class="status" id="liveData" ref="statusEcharts"></div>
            </div>
          </div>
        </el-card>
      </el-col>  
      <el-col>
        <!-- 历史数据 -->
        <div class="historyBox">
          <div class="status" id="historyData" ref="historyEcharts"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
let hischart = null;
export default {
data () {
  return {
      deviceNo:'',
      heart:'-',
      rr:'-',
      breathe:'-',
      offLineStatus:'',
      data2List:1,
      status:'',
      temp:'-',
      radarData:{},
      wifi:'-',
      act:'-',
      noise:'-',
      outduration:'-',
      breatheStatus:'正常',
      heartStatus:'正常',
      heartList:[], //实时心率数据
      breathList:[],
      timeList:[], 
      myChart:'',
      option:'',
      historyHeartList:[], //历史心率数据
      historyBreathList:[], //历史呼吸数据
      historyTimeList:[],//
      interval:null,
  }
},
mounted () {
  console.log(this.$route.query);
  this.deviceNo = this.$route.query.deviceNo;
  if(this.deviceNo == null){
    this.deviceNo = sessionStorage.getItem("deviceNo");
  }
  sessionStorage.setItem("deviceNo",this.deviceNo);
  this.getRealData();
  this.drawChart();
  this.interval = setInterval(() => {
    this.getRealData();
  }, 10 * 1000);
},
beforeDestroy(){
  if(this.interval!=null){
    clearInterval(this.interval);
    this.interval = null;
  }
},
destroyed(){
  hischart.clear();
  if(this.websock!=null){
    this.websock.close();
    this.websock = null;
  }
  if(this.interval != null){
    clearInterval(this.interval)
    this.interval = null;
  }
  if(this.time2!=null){
    clearInterval(this.time2);
    this.time2 = null;
  }
},
methods: {
  getRealData(){
    if(this.deviceNo == null){
      return;
    }
    this.$postJson(
        "dmc/qlRadar/showHealthHistoryData",
        {
          deviceNo:this.deviceNo,
          pageNum:1,
          pageSize:1
        }).then(res =>{
        console.log(res);
        if(res.code == 200){
          let statusList = [];
          res.result = res.result.list[0];
          if(res.result.offLine == 1){
            this.offLineStatus = "离线"
            this.heart = "-";
            this.breathe = "-";
            this.status = "-";
            this.rr = '-';
            this.goodData = "";
            this.breatheStatus = "";
            this.heartStatus = "";
            this.noise = '-';
            this.temp = '-';
            this.wifi = '-';
            this.act = '-';
            this.move = '-';
            this.hum = '-';
            this.human = '-';
            statusList.push('设备已离线');
            this.data2List = statusList;
          }else{
            this.noise = res.result.noise;
            this.outduration = res.result.outDuration;
            // 
            this.outduration = this.formatSeconds(res.result.outDuration);
            this.offLineStatus = "在线"
            if(res.result.heart == 255){
              res.result.heart = 0;
            }
            if(res.result.breath == 255){
              res.result.breath = 0;
            }
            if(res.result.inbed != 0){
              this.heart = res.result.heart;
              this.breathe = res.result.breath;
              if(this.breathe != 0 && this.breathe!=null){
                this.rr = (60 / this.breathe).toFixed(2);
              }else{
                this.rr = '-';
              }
              this.status = "离床";
            }else{
              this.heart = res.result.heart;
              this.breathe = res.result.breath;
              if(this.breathe != 0 && this.breathe!=null){
                this.rr = (60 / this.breathe).toFixed(2);
              }
              this.status = "在床";
            }
            
            statusList.push('状态:'+this.status);
            statusList.push('时间:'+res.result.createdTime);
            this.data2List = statusList;
            if(this.heart!=0 && this.breathe !=0){
               this.heartList.push(this.heart);
               this.breathList.push(this.breathe);
                this.timeList.push(res.result.createdTime);
                this.myChart.setOption(this.option); 
            }
            if(this.heart>100){
              this.heartStatus = "心率过快";
            }else if(this.heart<50){
              this.heartStatus = "心率过慢";
            }
            if(this.breathe>23){
              this.breatheStatus = "呼吸过快";
            }else if(this.breathe<12){
              this.breatheStatus = "呼吸过慢";
            }
          }
        }else{
          this.offLineStatus = "离线"
            this.heart = "-";
            this.breathe = "-";
            this.status = "-";
            this.goodData = "";
            this.breatheStatus = "";
            this.heartStatus = "";
            this.noise = '-';
            this.temp = '-';
        }
      })
  },
  showHistoryBreathChart(){
    hischart = echarts.init(document.getElementById("historyBreathData"));
    var option = {
      title: {
          text: "历史呼吸数据",
      },
      xAxis: {
        data: this.historyTimeList
      },
      yAxis: {},
      tooltip: {},
      legend: {
        data: ["呼吸"],
      },
      series: [
        {
          data: this.historyBreathList,
          type: 'line',
          stack: 'x',
          color: 'blue',
          smooth: true, //是否平滑曲线显示。折线会圆滑，不然false就会有折角
          symbolSize: 8, //标记的大小，点的大小'
          sampling: "average", //取过滤点的平均值
        }
      ]
    };
    hischart.setOption(option);
  },
  showHistoryChart(){
    hischart = echarts.init(document.getElementById("historyData"));
    var option = {
      // backgroundColor: ['#081944'], // 全图默认背景
      visualMap: [
        {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 100
        },
        {
          show: false,
          type: 'continuous',
          seriesIndex: 1,
          dimension: 0,
          min: 0,
          max: this.historyTimeList.length - 1
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
       dataZoom: [
              {
                type: "slider",
                show: this.historyTimeList.length>100,
                xAxisIndex: [0,1],
                start: 0,
                end: 10000/this.historyTimeList.length > 100?100:10000/this.historyTimeList.length
              },
            ],
      title: [
        {
          top: '2%',
          left: 'left',
          text: '历史心率',
          textStyle:{
             color: 'black'
          }
        },
        {
          top: '50%',
          left: 'left',
          text: '历史呼吸',
          textStyle:{
             color: 'black'
          }
        }
      ],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: [
        {
          axisLabel:{
            color:'black'
          },
          data: this.historyTimeList
        },
        {
          axisLabel:{
            color:'black'
          },
          data: this.historyTimeList,
          gridIndex: 1
        }
      ],
      yAxis: [
        {
          axisLabel:{
            color:'black'
          },
          min:50
        },
        {
          axisLabel:{
            color:'black'
          },
          gridIndex: 1,
          min:10
        }
      ],
      grid: [
        {
          bottom: '58%'
        },
        {
          top: '55%'
        }
      ],
      series: [
        {
          type: 'line',
          showSymbol: false,
          data: this.historyHeartList
        },
        {
          type: 'line',
          showSymbol: false,
          data: this.historyBreathList,
          xAxisIndex: 1,
          yAxisIndex: 1
        }
      ]
    };
    hischart.setOption(option);
  },
  drawChart() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById("liveData"));
    this.option = {
      // backgroundColor: ['#081944'], // 全图默认背景
      visualMap: [
        {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 100
        },
        {
          show: false,
          type: 'continuous',
          seriesIndex: 1,
          dimension: 0,
          min: 0,
          max: this.timeList.length - 1
        }
      ],
       dataZoom: [
              {
                type: "slider",
                show: this.timeList.length>100,
                xAxisIndex: [0,1],
                start: 0,
                end: 10000/this.timeList.length > 100?100:10000/this.timeList.length
              },
            ],
      title: [
        {
          top: '2%',
          left: 'right',
          text: '心率',
          textStyle:{
             color: 'black',
          }
        },
        {
          top: '52%',
          left: 'right',
          text: '呼吸',
          textStyle:{
             color: 'black',
          }
        }
      ],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: [
        {
          axisLabel:{
            color:'black'
          },
          data: this.timeList
        },
        {
          axisLabel:{
            color:'black'
          },
          data: this.timeList,
          gridIndex: 1
        }
      ],
      yAxis: [
        {
          axisLabel:{
            color:'black'
          },
          min:40
        },
        {
          axisLabel:{
            color:'black'
          },
          gridIndex: 1,
          min:5
        }
      ],
      grid: [
        {
          top: '4%',
          bottom: '57%',
          left: '6%',
          right:'5%'
        },
        {
          top: '94%',
          bottom: '49%',
          left: '6%',
          right:'5%'
        }
      ],
      series: [
        {
          type: 'line',
          showSymbol: false,
          data: this.heartList
        },
        {
          type: 'line',
          showSymbol: false,
          data: this.breathList,
          xAxisIndex: 1,
          yAxisIndex: 1
        }
      ]
    };
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(this.option);
  },
  formatSeconds(value) {
        var secondTime = parseInt(value);// 秒
        var minuteTime = 0;// 分
        var hourTime = 0;// 小时
        if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取余，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if(minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取余的分，获取分钟除以60取余的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        if(secondTime == null){
          secondTime = 30;
        }
        var result = "" + parseInt(secondTime) + "秒";

        if(minuteTime > 0) {
          result = "" + parseInt(minuteTime) + "分" + result;
        }
        if(hourTime > 0) {
          result = "" + parseInt(hourTime) + "小时" + result;
        }
        console.log('result',result);
        return result;
    },
}
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body{
  padding: 0px;
}
.box-card{
  width: 96%;
  margin-left: 2%;
  min-height: 160px;
  margin-top: 20px;
  font-size: 20px;
  background: #1395DB;
  text-align: center;
  .box_txt{
    font-size: 45px;
    text-align: center;
    padding-top: 80px;
    font-weight: bold;
    padding-bottom: 80px;
    background-color: #CCDCEB;
    color: #1195DB;
  }
}
.clearfix{
  background: #1395DB;
  color: white;
  img{
    width: 28px;
    height: 28px;
    margin-top: -6px;
    vertical-align: middle;
  }
}
.card2{
  font-size: 18px;
  padding: 5px;
  margin: 6px;

  text-align: left;
  background: #CCDCEB;
  color: #171C56;
}

.echartsBox {
  width: 100%;
  height: 420px;
}
.status {
  height: 420px;
  width: 100%;
}
.pageBox {
width: 100%;
// height: 100%;
background: #fff;
.el-row {
  height: 100%;
  .historyBox{
      height: 0px;
      width: 100%;
      margin-bottom: 30px;
      overflow: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }

  .leftBox {
    height: 100%;
    .titleBox {
      height: 50px;
      .el-col {
        line-height: 50px;
        .el-button {
          background: #ebc12b;
          border-color: #ebc12b;
        }
      }
      .inof {
        font-size: 24px;
        color: #4f4e4e;
        span {
          margin: 0 5px;
        }
      }
    }
    
  }
  .rightBox {
    height: 100%;
    padding-right: 20px;
    //   overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
    //   日历部分
    .dayBox {
      width: 100%;
      span {
        display: block;
        width: 46px;
        height: 41px;
        background-color: #ebc12b;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
        border-radius: 5px;
        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
    //  实时心率
    .realData {
      width: 100%;
      border: 1px solid #e1e3e9;
      margin-top: 20px;
      margin-bottom: 10px;
      box-sizing: border-box;
      //   标题
      .realTitle {
        height: 50px;
        background-color: #fafafa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #e1e3e9;
        .icon-- {
          color: #ee6666;
          font-size: 28px;
          margin-right: 10px;
        }
        span {
          color: #494949;
          font-size: 18px;
        }
      }
      // 健康概况
      .center {
        padding: 10px;
        background-color: #fafafa;
        border-bottom: 1px solid #e1e3e9;
        p {
          color: #3e3e3e;
          font-size: 16px;
        }
        .one {
          display: flex;
          span {
            width: 50%;
            display: flex;
            flex-wrap: nowrap;
            p {
              font-size: 14px;
              margin-right: 10px;
            }
            b {
              font-size: 14px;
            }
          }
        }
        div {
          margin: 7px 0;
          span {
            display: flex;
            flex-wrap: nowrap;
            p {
              font-size: 14px;
              margin-right: 10px;
            }
            b {
              font-size: 14px;
            }
          }
        }
      }
      // 异常状态
      .list {
        padding: 10px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        p {
          color: #3e3e3e;
          font-size: 16px;
        }
        span {
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          padding: 10px;
          box-shadow: 0 0 5px #f2f2f2;
          border-radius: 10px;
          box-sizing: border-box;
          p {
            font-size: 14px;
          }
          b {
            font-size: 14px;
          }
          &:nth-child(2) {
            p,
            b {
              color: #3FB212;
            }
          }
          &:nth-child(3) {
            p,
            b {
              color: #e57825;
            }
          }
          &:nth-child(4) {
            p,
            b {
              color: #62b3ff;
            }
          }
          &:nth-child(5) {
            p,
            b {
              color: #3FB212;
            }
          }
        }
      }
    }
  }
}
}
</style>